var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.00619507 4.44046V19.4718L8.43516 11.0722L-0.00619507 4.44046Z",
    fill: "#45AF77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.39 13.5665C12.2756 13.6564 12.1378 13.7016 12 13.7016C11.8622 13.7016 11.7244 13.6568 11.61 13.5665L9.43563 11.8583L0.889023 20.3624H23.111L14.5644 11.8583L12.39 13.5665Z",
    fill: "#45AF77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0062 19.4718V4.44046L15.5648 11.0722L24.0062 19.4718Z",
    fill: "#45AF77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9839 3.6371H1.0161L12 12.2668L22.9839 3.6371Z",
    fill: "#45AF77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.17bc8b66f9952b990c2472c6b398929a.svg";
export { ForwardRef as ReactComponent };